import { validateFormat } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { messageService } from '@/services/message';
import { useVuelidate } from '@vuelidate/core';
import { helpers, integer, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

const options = {
    messageTypes: [
        { value: 0, label: 'No Message' },
        { value: 1, label: 'Promotion' },
        { value: 2, label: 'Maintenance' },
        { value: 3, label: 'Disconnected' },
        { value: 4, label: 'Reward' },
        { value: 5, label: 'Facebook' },
        { value: 6, label: 'Purchase' },
        { value: 7, label: 'Quest' },
        { value: 8, label: 'Challenge' }
    ],
    creditTypes: [
        { value: 0, label: 'Chip' },
        { value: 1, label: 'Ruby' }
    ]
};

export default function () {
    const route = useRoute();
    const crudAction = useCrudActions();

    const model = reactive({
        accountIds: (route.query?.accountIds ?? '') as string,
        amount: 0,
        messageType: 0,
        creditType: 0
    });

    const validations = {
        accountIds: { required, format: validateFormat(/^[1-9][0-9]*(,[1-9][0-9]*)*$/) },
        amount: { required, integer, value: helpers.withMessage('Value can not be zero', val => val != 0) }
    };

    const v$ = useVuelidate(validations, model);

    const send = crudAction.excuteAndNotify({
        validator: v$,
        request: () =>
            model.messageType === 0
                ? messageService.add(model.accountIds, model.creditType, model.amount)
                : messageService.send(model.messageType, model.accountIds, model.creditType, model.amount),
        onSuccess: () => {
            model.amount = 0;
            model.messageType = 0;
            model.creditType = 0;
        },
        onFinally: () => v$.value.$reset()
    });

    return { model, v$, options, send };
}
